'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');let

NamespaceDirective=class NamespaceDirective extends BaseControllerBackedDirective{
get restrict(){
return'A';
}

get controller(){
return NamespaceDirectiveController;
}};let


NamespaceDirectiveController=class NamespaceDirectiveController{
static get $inject(){return['$rootScope','fatigueMeterTypeContentProviderService','groupTreeService']}

constructor($rootScope,fatigueMeterTypeContentProviderService,groupTreeService){
$rootScope.Pulsar={
lodash:_,
Formatters:require('../../../dist-es6/client/formatters'),
NotificationType:NotificationType,
contentProvider:fatigueMeterTypeContentProviderService,
groupTreeService:groupTreeService};

}};


module.exports=NamespaceDirective;
//# sourceMappingURL=namespaceDirective.js.map
